"use client";

import Link from "next/link";
import { useAuth } from "@/context/AuthContext";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Logo } from "@/components/ui/Logo";

export default function Navbar() {
    const { user } = useAuth();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    return (
        <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 dark:bg-slate-950/80 backdrop-blur-md border-b border-slate-200 dark:border-slate-800">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
                <div className="flex items-center gap-8">
                    <Logo width={160} height={40} />
                    <div className="hidden md:flex items-center gap-6">
                        <Link href="#how-it-works" className="text-sm font-medium text-slate-600 dark:text-slate-400 hover:text-blue-600 dark:hover:text-blue-500 transition-colors">
                            How It Works
                        </Link>
                        <Link href="#features" className="text-sm font-medium text-slate-600 dark:text-slate-400 hover:text-blue-600 dark:hover:text-blue-500 transition-colors">
                            Features
                        </Link>
                        <Link href="#pricing" className="text-sm font-medium text-slate-600 dark:text-slate-400 hover:text-blue-600 dark:hover:text-blue-500 transition-colors">
                            Pricing
                        </Link>
                    </div>
                </div>
                
                {/* Desktop Buttons */}
                <div className="hidden md:flex items-center gap-4">
                    {user ? (
                        <Link href="/dashboard" className="bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold py-2 px-4 rounded-lg transition-all shadow-md shadow-blue-500/20">
                            Go to Dashboard
                        </Link>
                    ) : (
                        <>
                            <Link href="/login" className="text-sm font-semibold text-slate-700 dark:text-slate-200 hover:text-blue-600 transition-colors">
                                Login
                            </Link>
                            <Link href="/signup" className="bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold py-2 px-4 rounded-lg transition-all shadow-md shadow-blue-500/20">
                                Start Free Trial
                            </Link>
                        </>
                    )}
                </div>

                {/* Mobile Menu Button */}
                <div className="md:hidden flex items-center">
                    <button
                        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                        className="text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white focus:outline-none p-2"
                        aria-label="Toggle mobile menu"
                    >
                        {isMobileMenuOpen ? (
                            <X className="w-6 h-6" />
                        ) : (
                            <Menu className="w-6 h-6" />
                        )}
                    </button>
                </div>
            </div>

            {/* Mobile Menu */}
            {isMobileMenuOpen && (
                <div className="md:hidden bg-white dark:bg-slate-950 border-t border-slate-200 dark:border-slate-800 px-4 pt-4 pb-6 shadow-xl absolute w-full left-0">
                    <div className="space-y-4">
                        <Link 
                            href="#how-it-works" 
                            className="block text-base font-medium text-slate-600 dark:text-slate-400 hover:text-blue-600 dark:hover:text-blue-500 transition-colors"
                            onClick={() => setIsMobileMenuOpen(false)}
                        >
                            How It Works
                        </Link>
                        <Link 
                            href="#features" 
                            className="block text-base font-medium text-slate-600 dark:text-slate-400 hover:text-blue-600 dark:hover:text-blue-500 transition-colors"
                            onClick={() => setIsMobileMenuOpen(false)}
                        >
                            Features
                        </Link>
                        <Link 
                            href="#pricing" 
                            className="block text-base font-medium text-slate-600 dark:text-slate-400 hover:text-blue-600 dark:hover:text-blue-500 transition-colors"
                            onClick={() => setIsMobileMenuOpen(false)}
                        >
                            Pricing
                        </Link>
                        <div className="pt-4 border-t border-slate-100 dark:border-slate-800 flex flex-col gap-3">
                            {user ? (
                                <Link 
                                    href="/dashboard" 
                                    className="block w-full text-center bg-blue-600 hover:bg-blue-700 text-white text-base font-semibold py-3 px-4 rounded-lg transition-all shadow-md shadow-blue-500/20"
                                    onClick={() => setIsMobileMenuOpen(false)}
                                >
                                    Go to Dashboard
                                </Link>
                            ) : (
                                <>
                                    <Link 
                                        href="/login" 
                                        className="block w-full text-center text-slate-700 dark:text-slate-200 font-semibold border border-slate-200 dark:border-slate-800 rounded-lg py-3 hover:bg-slate-50 dark:hover:bg-slate-900 transition-colors"
                                        onClick={() => setIsMobileMenuOpen(false)}
                                    >
                                        Login
                                    </Link>
                                    <Link 
                                        href="/signup" 
                                        className="block w-full text-center bg-blue-600 hover:bg-blue-700 text-white text-base font-semibold py-3 px-4 rounded-lg transition-all shadow-md shadow-blue-500/20"
                                        onClick={() => setIsMobileMenuOpen(false)}
                                    >
                                        Start Free Trial
                                    </Link>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </nav>
    );
}
